import { Breadcrumb, Button, Card, Typography } from 'antd';
import { useNavigate } from 'react-router';

import { useCreateMainPageMutation, useGetMainPagesQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { transformDateToCorrectFormat } from '../helpers';

import { OptionsCell } from './_components/OptionsCell/OptionsCell';
import { StatusTag } from './_components/StatusTag/StatusTag';
import styles from './MainCatalogPage.module.scss';

export const MainCatalogPage = () => {
  const navigate = useNavigate();

  const {
    data: pageVersionsData,
    isLoading: arePageVersionsLoading,
    isError: isPageDataFetchError,
  } = useGetMainPagesQuery();
  const [createPageVersion] = useCreateMainPageMutation();

  const sendApiRequest = useApiRequest();

  const createPageVersionHandler = () =>
    sendApiRequest({
      successMessage: 'Версия успешно создана',
      apiRequestCallback: () => createPageVersion(),
      successCallback: (response) => void navigate(`${response.id}`),
    });

  return (
    <FetchDataWrapper
      isLoading={arePageVersionsLoading}
      isError={isPageDataFetchError}
    >
      {pageVersionsData && (
        <div className={styles.wrapper}>
          <Breadcrumb items={[{ title: 'Публичные страницы' }, { title: 'Главная' }]} />
          <Button
            onClick={createPageVersionHandler}
            type="primary"
            size="large"
            className={styles['create-button']}
          >
            Создать черновик
          </Button>
          <div className={styles['versions-wrapper']}>
            {pageVersionsData.map(({ id, created_at: createdAt, active: isVersionPublished }) => (
              <Card
                key={id}
                classNames={{ body: styles['card-wrapper'] }}
              >
                <Typography.Text className={styles['version-title']}>
                  Версия {transformDateToCorrectFormat(createdAt)}
                </Typography.Text>
                <div className={styles['status-tag-wrapper']}>
                  <StatusTag
                    isPublished={isVersionPublished}
                    className={styles['status-tag']}
                  />
                </div>
                <div className={styles['options-cell-wrapper']}>
                  <OptionsCell
                    isVersionPublished={isVersionPublished}
                    id={id}
                  />
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}
    </FetchDataWrapper>
  );
};
